<app-loading-bar #loadingBar></app-loading-bar>
@if (!isSubmitted) {
  <div class="main-content" id="pdfTable" #pdfTable>
    <div class="consent-content">
      <h2 class="page-sub-title">T&C Acknowledgement</h2>
      <hr class="short-green-line" />
      <div class="page-content">
        <div class="content-section">
          <div class="content-title">
            <span>Customer details</span>
          </div>
          <table cellspacing="0">
            <tr>
              <td>Name</td>
              <td>{{ order?.orderSummary.name }}</td>
            </tr>
            <tr>
              <td>NRIC/Passport</td>
              <td>{{ order?.orderSummary.idvalue }}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{ order?.orderSummary.email }}</td>
            </tr>
            <tr>
              <td>Account Number</td>
              <td>{{ order?.orderSummary.faid }}</td>
            </tr>
            <tr>
              <td>Contact Number</td>
              <td>{{ order?.orderSummary.msisdn }}</td>
            </tr>
            @if (
              order?.orderSummary.address &&
              order?.orderSummary.address !== null
              ) {
              <tr
                >
                <td>Delivery Information</td>
                <td>{{ order?.orderSummary.address }}</td>
              </tr>
            }
          </table>
        </div>
        <div class="content-section" style="padding-top: 30px">
          <div class="content-title">
            <span> Order details </span>
          </div>
          <table cellspacing="0">
            <tr>
              <td>Order ID</td>
              <td>{{ order?.orderSummary.orderid }}</td>
            </tr>
            <tr>
              <td>Order Date</td>
              <td>{{ getOrderDate(order?.orderSummary.orderdate) }}</td>
            </tr>
            @for (items of order?.devices; track items) {
              @if (items.devicename && items.devicename !== null) {
                <tr>
                  <td>Device Model</td>
                  <td>
                    {{ items.devicename + " " }}
                    {{ items.storagesize !== null ? items.storagesize : "" }}
                  </td>
                </tr>
              }
              @if (items.color && items.color !== null) {
                <tr>
                  <td>Device Color</td>
                  <td>{{ items.color }}</td>
                </tr>
              }
              @if (items.contractype && items.contractype !== null) {
                <tr>
                  <td>Contract Type</td>
                  <td>{{ items.contractypedisplay }}</td>
                </tr>
              }
              @if (items.contractduration && items.contractduration !== null) {
                <tr
                  >
                  <td>Contract Period</td>
                  <td>{{ items.contractduration }}</td>
                </tr>
              }
            }
            @for (items of order?.additionalDevices; track items) {
              @if (items.accessoryname && items.accessoryname !== null) {
                <tr>
                  <td>Additional Device Name</td>
                  <td>{{ items.accessoryname }}</td>
                </tr>
              }
              @if (items.color && items.color !== null) {
                <tr>
                  <td>Additional Device Color</td>
                  <td>{{ items.color }}</td>
                </tr>
              }
              @if (items.contractype && items.contractype !== null) {
                <tr>
                  <td>Additional Contract Type</td>
                  <td>{{ items.contractypedisplay }}</td>
                </tr>
              }
              @if (items.contractduration && items.contractduration !== null) {
                <tr
                  >
                  <td>Additional Contract Period</td>
                  <td>{{ items.contractduration }}</td>
                </tr>
              }
            }
            @for (items of order?.orderSummaryItems; track items) {
              @if (
                items.cartitemtype === 'mobileCartItem') {
                <!-- mobileCartItem -->
                @if (items.servicenumber && items.servicenumber !== null) {
                  <tr>
                    <td>Telephone Number</td>
                    <td>{{ items.servicenumber }}</td>
                  </tr>
                }
                @if (items.planname && items.planname !== null) {
                  <tr>
                    <td>Mobile Rate Plan</td>
                    <td>{{ items.planname }}</td>
                  </tr>
                }
              } @else {
                @if (
                  items.cartitemtype === 'fixedVoiceCartItem') {
                  <!-- fixedVoiceCartItem -->
                  @if (items.servicenumber && items.servicenumber !== null) {
                    <tr>
                      <td>Telephone Number</td>
                      <td>{{ items.servicenumber }}</td>
                    </tr>
                  }
                  @if (items.planname && items.planname !== null) {
                    <tr>
                      <td>Fixed Voice Rate Plan</td>
                      <td>{{ items.planname }}</td>
                    </tr>
                  }
                } @else {
                  <!-- multiPlayCartItem -->
                  @if (items.servicenumber && items.servicenumber !== null) {
                    <tr>
                      <td>Modem ID</td>
                      <td>{{ items.servicenumber }}</td>
                    </tr>
                  }
                  @if (items.planname && items.planname !== null) {
                    <tr>
                      <td>Fibre Rate Plan</td>
                      <td>{{ items.planname }}</td>
                    </tr>
                  }
                }
              }
            }
          </table>
        </div>
        <div class="content-section">
          <div class="content-title">
            <span>Terms & conditions</span>
          </div>
          <div class="please-text">
            <span
              >Please read carefully and understand all the terms and conditions
              before providing your acknowledgement by clicking the "I Accept"
              button.</span
              >
            </div>
            <div class="content-title">
              <span>E-Acknowledgement</span>
            </div>
            <div
          [ngClass]="
            listOfTnC.length > 0 ? 'normal-content' : 'add-padding-to-content'
          "
              >
              <div class="d-flex">
                <div
                  class="check-box mr-2"
                  [ngClass]="{ checked: termscheck }"
                  (click)="termscheck = !termscheck"
                  >
                  @if (termscheck) {
                    <img src="assets/images/tick.svg" />
                  }
                </div>
                <span>I/We hereby declare that: </span>
              </div>
              <ol type="a" class="terms-text alpha">
                @for (items of listOfTnC; track items) {
                  <li class="d-flex my-2 t-c">
                    <span [innerHtml]="bypassSecurityTrustHtml(items.value)"></span>
                  </li>
                }
              </ol>
            </div>
            <div class="terms-text">
              <span>{{ acknowledgement_text }}</span>
            </div>
            <div class="padding-top-60">
              <button
                type="button"
                (click)="onSubmitConsentForm()"
                [disabled]="!termscheck || orderIsNotExist"
                class="btn btn-maxis-success button-accept"
            [ngStyle]="{
              height: withTimeStamp ? '80px' : '50px',
              'white-space': 'pre-line'
            }"
                >
                {{ acceptString }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <audio id="audio">
        <source src="./assets/02_DeviceGuard.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  }
